import { useEffect, useRef } from 'react'
import type { PointerEvent } from 'react'

// 목록의 줄을 끌어 여러 개를 한 번에 고르고 푼다(F-81).
// 누른 줄이 바뀔 값(고름 또는 풂)을 정하고, 누른 채 지나가는 줄은 그 값으로 맞춘다 — 뒤집지 않는다.
// 체크박스를 직접 누른 것은 체크박스가 제 값을 바꾸므로 줄은 끌기만 시작한다(두 번 바뀌면 제자리다).
export function useDragPick(isOn: (id: string) => boolean, set: (id: string, on: boolean) => void) {
  const drag = useRef<boolean | null>(null)
  useEffect(() => {
    const end = () => {
      drag.current = null
    }
    window.addEventListener('pointerup', end)
    window.addEventListener('pointercancel', end)
    return () => {
      window.removeEventListener('pointerup', end)
      window.removeEventListener('pointercancel', end)
    }
  }, [])
  return (id: string) => ({
    onPointerDown: (e: PointerEvent<HTMLElement>) => {
      if (e.button !== 0) return
      const on = !isOn(id)
      drag.current = on
      // 터치는 누른 요소가 포인터를 쥐어 다른 줄에 들어가는 신호가 오지 않는다 — 놓아 준다.
      if (e.currentTarget.hasPointerCapture?.(e.pointerId)) e.currentTarget.releasePointerCapture(e.pointerId)
      if (!(e.target as Element).closest('[role="checkbox"]')) set(id, on)
    },
    onPointerEnter: () => {
      if (drag.current !== null) set(id, drag.current)
    },
  })
}
